import React from 'react';

/**
 * ShipAssure logo with icon + text + tagline + bottom padding
 */
const ShipAssureLogo = ({ size = 32, className = '' }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      paddingBottom: '20px', // 👈 bottom padding added here
    }}
    className={className}
  >
    
    {/* ICON */}
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="ShipAssure logo"
    >
      <rect x="4" y="14" width="32" height="22" rx="3" fill="#1d4ed8" />
      <path d="M2 14 L20 7 L38 14 L20 21 Z" fill="#2563eb" />
      <line x1="20" y1="7" x2="20" y2="21" stroke="#93c5fd" strokeWidth="1.5" />
      <rect x="4" y="22" width="32" height="4" rx="1" fill="#1e40af" />
      <rect x="17.5" y="14" width="5" height="22" rx="1" fill="#1e40af" />
      <circle cx="30" cy="30" r="7" fill="#16a34a" />
      <polyline
        points="26.5,30 29,32.5 33.5,27.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>

    {/* TEXT + TAGLINE */}
    <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
      
      {/* Brand Name */}
      <div
        style={{
          fontFamily: 'Inter, sans-serif',
          fontWeight: 700,
          fontSize: size * 0.9,
        }}
      >
        <span style={{ color: '#111827' }}>Ship</span>
        <span style={{ color: '#2563EB' }}>Assure</span>
      </div>

      {/* Tagline (auto hide on small size optional) */}
      {size > 30 && (
        <div
          style={{
            fontSize: size * 0.35,
            color: '#6b7280',
          }}
        >
          Turn Every Shipment into Verified Proof
        </div>
      )}

    </div>

  </div>
);

export default ShipAssureLogo;